import { BulkOneClickPrintOrderLimit } from "@redotech/redo-fulfillment-common/bulk-shipment-print";
import * as z from "zod";

export const buyBulkShipmentLabels = {
  name: "buyBulkShipmentLabels" as const,
  input: z.object({
    fulfillmentGroupIds: z
      .array(z.string())
      .min(1)
      .max(BulkOneClickPrintOrderLimit),
    userId: z.string(),
    print: z.boolean(),
  }),
  output: z.object({ batchId: z.string(), batchNumber: z.string() }),
};
